<template>
  <div class='wrapper-page'>
    <modal ref='tagForm'>
      <template #header>
        <h5 v-if="!modalTag.hasOwnProperty('id')" class='modal-title mt-0'>{{$t('tags.create_tag')}}</h5>
        <h5 v-else class='modal-title mt-0'>{{$t('tags.list.edit')}}</h5>
      </template>

      <template #body>
        <form @submit.prevent='submitForm($event)'>
          <div class='modal-body'>
            <div class='form-group'>
              <label class='col-form-label'>
                {{$t('tags.list.name')}}
              </label>

              <input required='required' type='text' name='tag[name]' class='form-control' :value='modalTag.name'>
            </div>

            <div class='form-group'>
              <tag-color-picker :startingColor='modalTag.color' />
            </div>
          </div>
          <div class='modal-footer'>
            <input type='submit' name='commit' :value="$t('tag.save')" class='btn btn-primary'>
          </div>
        </form>
      </template>
    </modal>

    <modal ref='deleteModal'>
      <template #header>
        <h5 class='modal-title mt-0'>{{$t('tags.list.delete')}}</h5>
      </template>

      <template #body>
        <form @submit.prevent='deleteTag()'>
          <div class='modal-body'>
            {{$t('tags.list.are_you_sure')}}
          </div>

          <div class='modal-footer'>
            <input type='submit' value='Delete' class='btn btn-danger'>
            <input @click.prevent='$refs.deleteModal.close' type='submit' value='Close' class='btn btn-outline-primary'>
          </div>
        </form>
      </template>
    </modal>

    <import ref='import' />

    <div class='container-fluid text-center'>
      <h1 class='page-title'>{{$t('tags.title')}}
      <a :href="tagsVideo()" target="_blank" class="own-tooltip own-tooltip-bottom video-link" :data-tooltip="$t('tags.click_here_to_watch')"><img src="../assets/video.svg" /></a>
      </h1>

      <div class="clearfix"></div>

      <a href='#' class='btn btn-primary float-right add-tags m-l-10' @click.prevent='openModal($refs.tagForm)'>
        {{$t('tags.add')}}
      </a>

      <a href="#" @click.prevent="$refs.import.open" class="btn btn-outline-primary float-right">
        {{$t('products.tabs.import_product')}}
      </a>

      <filter-list />

      <div class="filter" v-if="selectedTags.length > 0">
        <div class="filters-set">
          <p>{{ $t('records_list.filters.tags') }} <strong>{{this.selectedTags.map(t => t.name).join(', ')}}</strong></p>
          <router-link :to="{ query: {} }" class="float-right">
            {{ $t('folders_list.clear_filters') }}
          </router-link>
        </div>
      </div>

      <div v-if='tags.length === 0 && !loading' class="empty-list-wrapper">
        <img src="../assets/empty_states/tags.png" />
        <p>{{$t('tags.empty_state')}}</p>
      </div>
      <table v-if='tags.length > 0 && !loading' class='table'>
        <thead>
          <tr>
            <th>{{$t('tags.list.name')}}</th>
            <th>{{$t('tags.list.actions')}}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for='tag in tags' :key='tag.id'>
            <td>
              <router-link :to="{ name: 'tag', params: { id: tag.id } }">
                {{tag.name}}
              </router-link>

              <div :class="['tag-small-circle', tag.color]">
              </div>
            </td>

            <td class='actions'>
              <ul>
                <li :title= "$t('tags.list.edit')">
                  <a @click.prevent='openModal($refs.tagForm, tag)' href='#' class='fas fa-edit'></a>
                </li>
                <li :title= "$t('tags.list.delete')">
                  <a @click.prevent='openModal($refs.deleteModal, tag)' href='#' class='fas fa-trash-alt'></a>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <loading v-if="loading" />

      <pagination :meta='meta' />
    </div>
  </div>
</template>
<script>
  import _modal from '../components/_modal'
  import _tagColorPicker from '../components/tags/_tag_color_picker'
  import _pagination from '../components/_pagination'
  import _loading from '../components/_loading'
  import _multi_select from '../components/shared/_infinite_multi_select'
  import _import from '../components/tags/_import'
  import _filter_list from '../components/shared/items/filters/_filter_list_for_tags'
  import _filter_list_from_params from '../components/shared/items/filters/_filter_list_for_tags'

  export default {
    components: {
      pagination: _pagination,
      'modal': _modal,
      'multi-select': _multi_select,
      'tag-color-picker': _tagColorPicker,
      'loading': _loading,
      'import': _import,
      'filter-list': _filter_list,
    },
    created() {
      this.loadTags()
    },
    data() {
      return {
        modalTag: {},
        loading: false
      }
    },
    watch: {
      query() {
        this.loadTags()
      }
    },
    computed: {
      tags() {
        return this.state.tags || []
      },
      selectedTags() {
        const tagIds = this.query.tags_id || []
        return this.tags.filter(t => tagIds.indexOf(t.id.toString()) >= 0)
      },
    },
    methods: {
      loadTags() {
        this.loading = true

        this.store.sendMetrics({name: 'tags', params: this.$route.params, path: this.$route.fullPath})

        this.store.getTags(this.query).then(() => {
          this.loading = false
        })
      },
      openModal(modal, tag) {
        this.modalTag = Object.assign({ color: 'blue' }, tag)
        modal.open()
      },
      submitForm(event) {
        let promise = null

        if (this.modalTag.id) {
          promise = this.store.updateTag(this.modalTag.id, new FormData(event.target))
          this.store.sendMetrics({name: 'update_tag', params: this.$route.params, path: this.$route.fullPath})
        } else {
          promise = this.store.createTag(new FormData(event.target))
          this.store.sendMetrics({name: 'add_tag', params: this.$route.params, path: this.$route.fullPath})
        }

        promise.then(() => {
          this.loadTags()
          this.$refs.tagForm.close()
        })
      },
      deleteTag() {
        this.store.destroyTag(this.modalTag.id).then(() => {
          this.store.sendMetrics({name: 'remove_tag', params: this.$route.params, path: this.$route.fullPath})
          this.removeTag(this.modalTag.id)
          this.loadTags()
          this.$refs.deleteModal.close()
        })
      },
      tagsVideo() {
        return this.locale === 'de' ? 'https://relatico.wistia.com/medias/g1qjunfbum' : 'https://relatico.wistia.com/medias/jj4o18m8so'
      },
    }
  }
</script>

<style lang='sass' scoped>
  @import '../styles/tags'
  .page-title
    max-width: 100%
    width: 75%
    text-align: left
    a
      font-size: 12px
      line-height: 18px
  .expiration-cont
    float: left
    width: 100%
  .file-name
    max-width: 400px
    a.record
      text-overflow: ellipsis
      overflow: hidden
  .folder-name-limit
    max-width: 300px
    a
      white-space: pre-line
  .filter-all-records
    form
      text-align: left
      label
        text-align: left
        display: block
      .form-group
        margin-bottom: 20px
      .form-inline
        label
          width: 20%
          &:first-child
            width: 50%
          &:last-child
            width: 5%
            color: #686868
            cursor: pointer
  .filter
    .filter-by
      float: left
  .m-l-10
    margin-left: 10px
</style>
